import React, {useState} from 'react';
import * as css from './style.css';
import Btn from '../../../component/button/btn/Btn';
import Checkbox from '../../../component/checkbox/Checkbox';
import {useTranslation} from 'react-i18next';
import Card from './card/card';
import {OrderData} from '../suspendedConfirmation';

const WillComePaymentApproval = ({orderData, approvePayment}: {orderData: OrderData, approvePayment: any}) => {
    const [approved, setApproved] = useState(false);
    const {t} = useTranslation('suspendedConfirmation');

    return (
        <Card
            mainTitle={
                <>
                    {t('approveTitle', {nameFirst: orderData.nameFirst})}
                    <br />
                    {t('subtitle')}
                </>
            }
            subTitle={orderData.eventTitle}
            {...orderData}
        >

            <css.confirmationBox>
                <css.confirmationHeader>
                    <css.titleCenter>{t('arrivalConfirmationTitle')}</css.titleCenter>
                    <css.boldText>
                        {t('orderNumber', {oid: orderData.oid})}
                    </css.boldText>
                </css.confirmationHeader>

                <css.ticketInfo>{`${t(orderData.ticketsAmount > 1 ? 'multipleTickets':'singleTicket', {amount: orderData.ticketsAmount})} ${orderData.ticketTitle}`}</css.ticketInfo>

                {orderData.creditCard && (
                    <css.infoRow>
                        <css.infoValue>************{orderData.creditCard}</css.infoValue>
                    </css.infoRow>
                )}
          
                <css.infoRow>
                    <css.infoValue>{orderData.email}</css.infoValue>
                    <div>{t('email')}</div>
                </css.infoRow>
          
                <css.infoRow>
                    <css.infoValue>{orderData.phone}</css.infoValue>
                    <div>{t('sms')}</div>
                </css.infoRow>
          
                <css.checkboxRow>
                    <Checkbox 
                        classes={undefined} 
                        onClick={setApproved} 
                        color={undefined} 
                        selected={approved} 
                    />
                    <span>{t('approveArrival')}</span>
                </css.checkboxRow>
            </css.confirmationBox>
                
            <css.buttonRow>
                <Btn onClick={approvePayment}>{t('finish')}</Btn>
                <Btn className="white" onClick={undefined}>{t('cancel')}</Btn>
            </css.buttonRow>
                
        </Card>
    );
};

export default WillComePaymentApproval;